module.exports = __webpack_public_path__ + "img/icon_benefit_04.b4dbe2e9.svg";